// Submit each purchase once; only status checks may be retried.
export function createTempDownloader({
  request,
  getToken,
  now = () => Date.now(),
  sleep = ms => new Promise(resolve => setTimeout(resolve, ms)),
  requestId = () => `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`,
}) {
  const inFlight = new Map();

  async function run(params, token) {
    const assertSession = () => {
      if (!token || token !== getToken()) throw new Error("登录状态已变化，请重新进入次卡页面");
    };
    const body = { ...params, async: true, requestId: requestId() };
    let job;
    assertSession();
    try {
      job = await request("submit", body);
    } catch (error) {
      if (error.tempTaskTerminal) throw error;
      // Legacy servers ignore requestId, so retrying an uncertain submit can charge twice.
      throw new Error("未能确认任务状态，请先查看下载记录，勿反复提交");
    }
    const deadline = now() + 10 * 60 * 1000;
    let networkErrors = 0;
    while (true) {
      assertSession();
      // Older buy_temp endpoints ignore async and return the completed download directly.
      if (job && !job.status && typeof job.downloadUrl === "string" && job.downloadUrl.trim()) {
        return job;
      }
      if (job && job.status === "success" && job.result && job.result.code === 0 && job.result.data && job.result.data.downloadUrl) {
        return job.result.data;
      }
      if (job && job.status === "failed") {
        throw new Error((job.result && job.result.msg) || "下载失败，请联系客服");
      }
      if (!job || job.status !== "pending" || !job.taskId) {
        throw new Error("任务记录已失效，请先查看下载记录，勿反复提交");
      }
      if (now() >= deadline) throw new Error("下载仍在处理，请稍后查看下载记录，勿反复提交");
      await sleep(4000);
      assertSession();
      try {
        job = await request("check", { taskId: job.taskId });
        networkErrors = 0;
      } catch (error) {
        if (error.tempTaskTerminal) throw error;
        if (++networkErrors >= 5) throw new Error("暂时无法查询结果，后台可能仍在处理，请稍后查看下载记录");
      }
    }
  }

  return params => {
    const token = getToken();
    const key = JSON.stringify([token, params.imageID, params.webType, params.format, !!params.isCos]);
    if (inFlight.has(key)) return inFlight.get(key);
    const promise = run(params, token).then(
      result => { inFlight.delete(key); return result; },
      error => { inFlight.delete(key); throw error; }
    );
    inFlight.set(key, promise);
    return promise;
  };
}
